import React, { memo, useState } from 'react';
import { Button } from 'appkit-react';
import { Table, Tooltip } from 'antd';
import './index.scss';

function ResentEmailTitleCell({ tableData, resentEmail }) {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);

  const tableColumns = [
    {
      title: 'Email Address',
      dataIndex: 'email',
    },
    {
      title: 'Status',
      dataIndex: 'inviteStatus',
      render: (_, record, index) => {
        const value = record.inviteStatus;

        if (!value) {
          return null;
        }
        return (
          <div className="client-column-item invite-status">
            <div className={`status ${value}`}>{value}</div>
          </div>
        );
      },
    },
  ];

  const cancelTooltip = () => {
    if (
      document.getElementsByClassName('ant-tooltip-open') &&
      document.getElementsByClassName('ant-tooltip-open')[0]
    ) {
      document.getElementsByClassName('ant-tooltip-open')[0].click();
    }
  };

  return (
    <Tooltip
      trigger={['click']}
      placement="bottom"
      title={() => (
        <div>
          <div className="content">
            <Table
              pagination={false}
              rowKey="email"
              rowSelection={{
                type: 'checkbox',
                selectedRowKeys,
                onChange: (newSelectedRowKeys, newSelectedRows) => {
                  console.log(
                    ':newSelectedRowKeys',
                    newSelectedRowKeys,
                    newSelectedRows,
                  );
                  setSelectedRowKeys(newSelectedRowKeys);
                  setSelectedRows(newSelectedRows);
                },
              }}
              columns={tableColumns}
              dataSource={tableData.filter(
                (item) => item.inviteStatus !== 'Accepted',
              )}
            />
          </div>
          <div className="foother">
            <Button
              className="cancel-btn"
              kind="secondary"
              size="lg"
              isLoading={btnLoading}
              onClick={cancelTooltip}
            >
              Cancel
            </Button>
            <Button
              className="resent-btn"
              kind="primary"
              size="lg"
              isLoading={btnLoading}
              onClick={async () => {
                setBtnLoading(true);
                await resentEmail(selectedRows);
                cancelTooltip();
                setBtnLoading(false);
              }}
            >
              Resend
            </Button>
          </div>
        </div>
      )}
    >
      <a onClick={(e) => e.preventDefault()}>Resend All Invites</a>
    </Tooltip>
  );
}

export default memo(ResentEmailTitleCell);
